import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'kt-unitrate',
	templateUrl: './unitrate.component.html',
	styleUrls: ['./unitrate.component.scss']
})
export class UnitrateComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
